// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1K-Xl","inputWrap":"styles_inputWrap__1umLM","input":"styles_input__1iTFP"};